import Footer from "./Footer";
import {Image} from "react-bootstrap";
import './StudentsGallery.css';

let DisseminationGallery = () => {
    const verticalImageList = [
        "Spotkanie_2.jpeg",
        "Spotkanie_4.jpeg"    
    ]

    const horizontalImageList = [
        "Spotkanie_1.jpeg",
        "Spotkanie_3.jpeg",
        "Spotkanie_5.jpeg",
        "Spotkanie_6.jpeg",
        "Spotkanie_7.jpeg",
        "Spotkanie_8.jpeg",
        "Spotkanie_9.jpeg",
        "Spotkanie_10.jpeg",
        "Spotkanie_11.jpeg",
        "Spotkanie_12.jpeg",
        "Spotkanie_13.jpeg",
        "Spotkanie_14.jpeg",
        "Spotkanie_15.jpeg",
        "Spotkanie_16.jpeg"
    ]

    return(
        <div className="content text-center">
            
            <div>
                {horizontalImageList.map(path => <Image className="imageHorizontal m-3" src={require("./img/galeria-upowszechnianie/" + path)} rounded />)}
            </div>

            <div>
                {verticalImageList.map(path => <Image className="imageVertical m-3" src={require("./img/galeria-upowszechnianie/" + path)} rounded />)}
            </div>

        </div>
    )
}

export default DisseminationGallery;